import script from "./OrganisationCredentials.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganisationCredentials.vue?vue&type=script&setup=true&lang=js"

import "./OrganisationCredentials.vue?vue&type=style&index=0&id=448c5867&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-448c5867"]])

export default __exports__